var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"menu",staticClass:"context-menu",style:(_vm.contextMenuStyle)},[_vm._t("default",[_vm._v("No Content!")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }